<div class="side-dialog__loader">
  <app-loader class="base-loader"></app-loader>
</div>
